export const hostedPageType = {
  checkoutNew: "checkout_new",
  checkoutExisting: "checkout_existing",
  checkoutOnetime: "checkout_onetime",
  portal: "portal",
  checkoutGift: "checkout_gift",
  collectNow: "collect_now"
};

export const postPaymentActionsApiConfig = {
  checkout_for_items: {
    apiGroup: "generic",
    apiAction: "bulk",
    cbSource: "viaHp"
  },
  portalPI: {
    apiGroup: "customers",
    apiAction: "create_payment_source_using_pi",
    contentType: "application/x-www-form-urlencoded"
  },
  checkout: {
    apiGroup: "subscriptions",
    apiAction: "create",
    cbSource: "viaHp",
    contentType: "application/x-www-form-urlencoded"
  },
  collectNow: {
    apiGroup: "customers",
    apiAction: "collect_payment",
    cbSource: "viaHp",
    contentType: 'application/json'
  }
};
